import React, { useMemo } from 'react';

import {
  ApiOutlined,
  AppstoreOutlined,
  ClockCircleOutlined,
  DeploymentUnitOutlined,
  MergeOutlined,
  SettingOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';

import { CoreEnums } from '@/utils/domain/constants';
import { getLightBackground } from '@/utils/infrastructure/utilities';
import UserAvatar from '../UserAvatar';
import styles from './style.less';

const { JsonDataCreatorResourceType } = CoreEnums;

const USER_LIKE_TYPES = new Set([
  JsonDataCreatorResourceType.Unknown,
  JsonDataCreatorResourceType.User,
  JsonDataCreatorResourceType.ExternalUser,
  JsonDataCreatorResourceType.AgentOnBehalfUser,
]);

const DataCreator = (props) => {
  const resourceType = Number(props.resourceType);

  const state = useMemo(
    () => ({
      fullName: props.resourceDisplay,
      id: props.resourceIdentifier,
      type: Number.isFinite(resourceType) ? resourceType : JsonDataCreatorResourceType.Unknown,
    }),
    [props.resourceDisplay, props.resourceIdentifier, resourceType],
  );

  const isUser = USER_LIKE_TYPES.has(state.type);
  const isAgent = state.type === JsonDataCreatorResourceType.Agent;

  const sizeStyle = useMemo(() => {
    if (!props.size) return {};
    return props.iconOnly ? { width: props.size } : {};
  }, [props.size, props.iconOnly]);

  const iconProps = useMemo(() => {
    // Unknown / user-like types render UserPicture (photo or initials), not a type icon.
    if (isUser) return undefined;

    const item = {
      [JsonDataCreatorResourceType.Agent]: { icon: '✨', color: '#F0BF10' },
      [JsonDataCreatorResourceType.Webhook]: { icon: <ApiOutlined />, color: '#296CFF' },
      [JsonDataCreatorResourceType.ProcessTrigger]: {
        icon: <ThunderboltOutlined />,
        color: '#FF5B70',
      },
      [JsonDataCreatorResourceType.BulkTask]: { icon: <AppstoreOutlined />, color: '#F0BF10' },
      [JsonDataCreatorResourceType.ProcessInstanceActionStartProcess]: {
        icon: <MergeOutlined />,
        color: '#676F8F',
      },
      [JsonDataCreatorResourceType.ScheduledProcess]: {
        icon: <ClockCircleOutlined />,
        color: '#0DC26B',
      },
      [JsonDataCreatorResourceType.SystemAutomation]: {
        icon: <SettingOutlined />,
        color: '#676F8F',
      },
      [JsonDataCreatorResourceType.ProcessInstance]: {
        icon: <DeploymentUnitOutlined />,
        color: '#296CFF',
      },
    }[state.type];

    if (!item) return {};
    return {
      icon: item.icon,
      style: getLightBackground(item.color),
    };
  }, [isUser, state.type]);

  return (
    <div className={styles.userAvatar} style={sizeStyle}>
      <UserAvatar
        {...state}
        iconOnly={props.iconOnly}
        isUser={isUser || isAgent}
        isAgent={isAgent}
        size={props.size}
        styles={sizeStyle}
        iconProps={iconProps}
      />
    </div>
  );
};

export default DataCreator;
